import {
  SET_USERS_LIST,
  SET_OPEN_SIDEBAR,
  SET_USERS_EDIT,
  SET_MODAL_DELETE_USERS,
  SET_USERS_FOR_DELETE,
  SET_USER_BY_ID,
  SET_POST_USER_FIRST_STEP,
  SET_CLEAR_USER_FOR_EDIT,
} from '@App/constantes/actions'
import { UserState, Constants } from '@App/store/user/types'

const initialState: UserState = {
  current: null,
  initialValue: null,
  users: [],
  isOpen: false,
  isEditUser: {},
  isDeleteModalOpen: false,
  userForDelete: null,
  resetForm: false,
  userById: {},
}

const usersReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case Constants.RESET_USER:
      return {
        ...state,
        resetForm: action.payload ? action.payload : !state.resetForm,
      }
    case SET_CLEAR_USER_FOR_EDIT:
      return {
        ...state,
        isEditUser: {},
      }
    case SET_POST_USER_FIRST_STEP:
      const { payload: postUserFirstStep } = action

      return {
        ...state,
        userFirstStep: postUserFirstStep,
      }
    case SET_USERS_LIST:
      const { payload } = action
      return {
        ...state,
        users: payload,
      }
    case SET_OPEN_SIDEBAR:
      return {
        ...state,
        isOpen: !state.isOpen,
      }
    case SET_USERS_EDIT:
      return {
        ...state,
        isEditUser:
          state.users.filter((item: any) => item.id === action.payload)[0] ||
          {},
      }
    case SET_MODAL_DELETE_USERS:
      return {
        ...state,
        isDeleteModalOpen: !state.isDeleteModalOpen,
      }
    case SET_USERS_FOR_DELETE:
      const userDelete =
        state.users.filter((item: any) => item.id === action.payload)[0] || {}
      return {
        ...state,
        userForDelete: userDelete,
      }
    case SET_USER_BY_ID:
      const { payload: user } = action
      return {
        ...state,
        userById: user,
      }
    case Constants.SET_CURRENT:
      return {
        ...state,
        current: action.payload,
      }
    default:
      return state
  }
}

export default usersReducer
